import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=d58be49e&scoped=true"
import script from "./prescription.vue?vue&type=script&lang=js"
export * from "./prescription.vue?vue&type=script&lang=js"
import style0 from "./prescription.vue?vue&type=style&index=0&id=d58be49e&prod&lang=scss&scoped=true"
import style1 from "./prescription.vue?vue&type=style&index=1&id=d58be49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58be49e",
  null
  
)

export default component.exports